import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-43">
      <div className="absolute left-0 top-1/2 w-64 h-64 bg-amber-500/10 rounded-full blur-[100px] pointer-events-none transform -translate-y-1/2" data-id="element-44" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#1A1A1A] rounded-3xl p-10 md:p-16 text-center border border-white/10 shadow-2xl" data-id="element-46">
          <div className="inline-flex justify-center items-center w-16 h-16 rounded-full bg-amber-500/20 text-amber-500 mb-8" data-id="element-47">
            <CalendarDays className="w-8 h-8" data-id="element-48" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-49">
            ¿Qué cambia en 7 días?
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed font-medium" data-id="element-50">
            "En la primera semana, verás correos respondidos sin tu
            intervención, seguimientos automáticos enviados, y una base de datos
            organizada con nuevos prospectos."
          </p>
        </motion.div>
      </div>
    </section>;
}